<template>
  <div class="hold-transition">
    <div class="wrapper">
      <loading v-if="cargando" />
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Choferes</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item active">Administrativo</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Choferes</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <!-- Header con botones de acción -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card shadow-sm border-0"
                  :class="$store.getters.getDarkMode ? 'bg-dark' : 'bg-white'"
                >
                  <div
                    class="card-header border-0 py-3"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5
                          class="mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-users me-2 text-primary"></i>
                          Gestión de Choferes
                        </h5>
                        <p class="mb-0 text-muted small">
                          Administra la información de choferes y sus documentos
                        </p>
                      </div>
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          @click="getIndex()"
                          data-bs-toggle="tooltip"
                          title="Actualizar datos"
                        >
                          <i class="fas fa-sync-alt fa-spin me-1"></i>
                          Actualizar
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-info"
                          @click="pivotTable()"
                          v-if="
                            $store.getters.can('argentina.choferes.pivotTable')
                          "
                          data-bs-toggle="tooltip"
                          title="Vista de tabla dinámica"
                        >
                          <i class="fas fa-scroll me-1"></i>
                          Tabla Dinámica
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-success"
                          data-toggle="modal"
                          data-target="#modal_form_chofer_export"
                          v-if="$store.getters.can('argentina.choferes.export')"
                          data-bs-toggle="tooltip"
                          title="Exportar a Excel"
                        >
                          <i class="far fa-file-excel me-1"></i>
                          Exportar
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          v-if="$store.getters.can('argentina.choferes.create')"
                          @click="create()"
                          data-bs-toggle="tooltip"
                          title="Crear nuevo chofer"
                        >
                          <i class="fas fa-plus me-1"></i>
                          Nuevo Chofer
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sección de filtros -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card"
                  :class="
                    $store.getters.getDarkMode
                      ? 'bg-dark border-secondary'
                      : 'bg-white'
                  "
                >
                  <div
                    class="card-header py-2"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <h6
                      class="mb-0"
                      :class="
                        $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                      "
                    >
                      <i class="fas fa-filter me-2"></i>
                      Filtros de Búsqueda
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <!-- Filtro Tipo Documento -->
                      <div class="col-md-2 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-id-card me-1"></i>
                          Tipo Doc.
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.tipo_documento"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="tipo_documento in tiposDocumentoArgentina"
                            :key="tipo_documento.numeracion"
                            :value="tipo_documento.numeracion"
                          >
                            {{ tipo_documento.descripcion }}
                          </option>
                        </select>
                      </div>

                      <!-- Filtro Número Documento -->
                      <div class="col-md-2 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-hashtag me-1"></i>
                          N° Documento
                        </label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.numero_documento"
                          @keyup="getIndex()"
                          placeholder="Buscar número..."
                        />
                      </div>

                      <!-- Filtro Nombre -->
                      <div class="col-md-3 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-user me-1"></i>
                          Nombre
                        </label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.nombre"
                          @keyup="getIndex()"
                          placeholder="Buscar nombre..."
                        />
                      </div>

                      <!-- Filtro Estado -->
                      <div class="col-md-2 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>

                      <!-- Filtro Empresa -->
                      <div class="col-md-3 form-group">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="listasForms.selct_empresa"
                          placeholder="Buscar empresa..."
                          label="razon_social"
                          class="form-control form-control-sm p-0"
                          :options="empresas"
                          :filterable="false"
                          @search="buscarEmpresas"
                          @input="getIndex()"
                        ></v-select>
                      </div>

                      <!-- Botón limpiar filtros -->
                      <div class="col-md-2 form-group mt-2 pt-3">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm w-100"
                          @click="limpiarFiltros()"
                        >
                          <i class="fas fa-eraser me-1"></i>
                          Limpiar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenido principal - Solo Tabla -->
            <div
              class="card"
              :class="
                $store.getters.getDarkMode
                  ? 'bg-dark border-secondary'
                  : 'bg-white'
              "
            >
              <div
                class="card-header py-2"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <h6
                    class="mb-0"
                    :class="
                      $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                    "
                  >
                    <i class="fas fa-table me-2"></i>
                    Lista de Choferes
                  </h6>
                  <span class="badge bg-primary">
                    {{ choferes.total || 0 }} registros
                  </span>
                </div>
              </div>

              <div class="card-body p-0">
                <div class="table-responsive text-nowrap text-center">
                  <table
                    class="table table-hover table-striped mb-0 table-bordered"
                    :class="$store.getters.getDarkMode ? 'table-dark' : ''"
                  >
                    <thead
                      class="text-center bg-dark"
                      :class="
                        $store.getters.getDarkMode
                          ? 'table-dark'
                          : 'table-light'
                      "
                    >
                      <tr>
                        <th class="text-center" style="width: 80px">
                          <i class="fas fa-image"></i>
                        </th>
                        <th>
                          <i class="fas fa-id-card me-1"></i>
                          Tipo Doc.
                        </th>
                        <th>
                          <i class="fas fa-hashtag me-1"></i>
                          N° Documento
                        </th>
                        <th>
                          <i class="fas fa-user me-1"></i>
                          Nombre Completo
                        </th>
                        <th>
                          <i class="fas fa-phone me-1"></i>
                          Teléfono
                        </th>
                        <th>
                          <i class="fas fa-id-badge me-1"></i>
                          Categoría Reg.
                        </th>
                        <th>
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Localidad
                        </th>
                        <th>
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </th>
                        <th>
                          <i class="fas fa-file-alt me-1"></i>
                          Documentos
                        </th>
                        <th class="text-center">
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </th>
                        <th class="text-center">
                          <i class="fas fa-cogs me-1"></i>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in choferes.data" :key="item.id">
                        <td class="text-center align-middle">
                          <a
                            v-if="item.link_fotografia"
                            :href="uri_docs + item.link_fotografia"
                            target="_blank"
                            class="d-inline-block"
                          >
                            <img
                              :src="uri_docs + item.link_fotografia"
                              alt="Chofer"
                              class="rounded shadow-sm"
                              style="
                                width: 50px;
                                height: 50px;
                                object-fit: cover;
                              "
                            />
                          </a>
                          <div
                            v-else
                            class="d-flex align-items-center justify-content-center rounded"
                            :class="
                              $store.getters.getDarkMode
                                ? 'bg-secondary'
                                : 'bg-light'
                            "
                            style="width: 50px; height: 50px; margin: 0 auto"
                          >
                            <i class="fas fa-user text-muted"></i>
                          </div>
                        </td>
                        <td>
                          <span class="badge bg-info">{{ item.tipoDoc }}</span>
                        </td>
                        <td>
                          <span
                            class="fw-bold"
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ item.numero_documento }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ item.nombres + " " + item.apellidos }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ item.celular_principal }}
                          </span>
                        </td>
                        <td>
                          <span class="badge bg-secondary">{{
                            item.categoriaLic
                          }}</span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ item.loc }}
                          </span>
                        </td>
                        <td>
                          <div
                            v-if="item.empresas && item.empresas.length > 0"
                            class="d-flex flex-column gap-1"
                          >
                            <span
                              v-for="empresas in item.empresas"
                              :key="empresas.id"
                              :class="
                                $store.getters.getDarkMode
                                  ? 'text-light'
                                  : 'text-dark'
                              "
                            >
                              {{ empresas.razon_social }}
                            </span>
                          </div>
                          <span v-else class="text-muted small"
                            >Sin empresa</span
                          >
                        </td>
                        <td>
                          <div class="d-flex flex-column gap-1">
                            <span
                              v-if="item.documentos_vencidos.length > 0"
                              class="badge bg-danger mt-1"
                            >
                              <i class="fas fa-exclamation-triangle me-1"></i>
                              Vencidos ({{ item.documentos_vencidos.length }})
                            </span>
                            <span
                              v-if="item.paquetes.length <= 0"
                              class="badge bg-danger mt-1"
                            >
                              <i class="fas fa-times me-1"></i>
                              Sin paquete
                            </span>
                            <span
                              v-if="item.documentos_pendientes.length > 0"
                              class="badge bg-warning mt-1"
                            >
                              <i class="fas fa-clock me-1"></i>
                              Pendientes ({{
                                item.documentos_pendientes.length
                              }})
                            </span>
                            <span
                              v-if="item.documentos_no_verificados.length > 0"
                              class="badge bg-info mt-1"
                            >
                              <i class="fas fa-question me-1"></i>
                              No verificados ({{
                                item.documentos_no_verificados.length
                              }})
                            </span>
                            <span
                              v-if="
                                item.documentos_vencidos.length === 0 &&
                                  item.documentos_pendientes.length === 0 &&
                                  item.documentos_no_verificados.length === 0 &&
                                  item.paquetes.length > 0
                              "
                              class="badge bg-success mt-1"
                            >
                              <i class="fas fa-check me-1"></i>
                              Verificado
                            </span>
                          </div>
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            data-toggle="modal"
                            data-target="#modal-form-estado"
                            style="cursor: pointer"
                            v-if="
                              $store.getters.can(
                                'argentina.choferes.editStatusHSE',
                              )
                            "
                            v-bind:class="[
                              item.estado == 1 ? 'bg-success' : 'bg-danger',
                            ]"
                            @click="llenarModal(item)"
                          >
                            {{ item.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                          </span>
                          <span
                            class="badge"
                            v-else
                            v-bind:class="[
                              item.estado == 1 ? 'bg-success' : 'bg-danger',
                            ]"
                          >
                            {{ item.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                $store.getters.can(
                                  'argentina.choferes.editarTransportadora',
                                ) && !admin
                              "
                              @click="edit(item, 3)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-info"
                              v-else-if="
                                $store.getters.can('argentina.choferes.show')
                              "
                              @click="edit(item, 1)"
                              title="Ver detalles"
                            >
                              <i class="fas fa-eye"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                empresa.length > 0 &&
                                  item.tipo_propiedad == 1 &&
                                  item.empresas.length > 0 &&
                                  empresa[0].id == item.empresas[0].id &&
                                  $store.getters.can('argentina.choferes.edit')
                              "
                              @click="edit(item, 2)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-else-if="
                                (empresa.length === 0 ||
                                  item.tipo_propiedad != 1) &&
                                  $store.getters.can('argentina.choferes.edit')
                              "
                              @click="edit(item, 2)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-secondary"
                              data-toggle="modal"
                              data-target="#modal-historial-estado"
                              v-if="
                                $store.getters.can('argentina.choferes.show')
                              "
                              @click="
                                llenarModalHistorial('App\\Conductor', item.id)
                              "
                              title="Ver historial"
                            >
                              <i class="fas fa-history"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-danger"
                              data-toggle="modal"
                              data-target="#modal-confirmar-eliminar"
                              v-if="
                                $store.getters.can('argentina.choferes.destroy')
                              "
                              @click="destroy(item)"
                              title="Eliminar"
                            >
                              <i class="fas fa-trash-alt"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div
                  v-if="!choferes.data || choferes.data.length === 0"
                  class="text-center py-5"
                >
                  <h5 class="text-muted">No hay choferes para mostrar</h5>

                  <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Cargando...</span>
                    </div>
                    <p class="mt-2 text-muted">Cargando Choferes..</p>
                  </div>
                </div>
              </div>
              <div
                class="card-footer border-0"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div v-if="choferes.total">
                    <p class="mb-0 small text-muted">
                      Mostrando del
                      <span class="fw-bold text-primary">{{
                        choferes.from
                      }}</span>
                      al
                      <span class="fw-bold text-primary">{{
                        choferes.to
                      }}</span>
                      de un total:
                      <span class="fw-bold text-primary">{{
                        choferes.total
                      }}</span>
                      registros
                    </p>
                  </div>
                  <div v-else>
                    <span class="badge bg-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination
                    :data="choferes"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    class="float-right m-0"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ChoferEstado ref="ChoferEstado" />
        <ChoferExport ref="ChoferExport" />
        <HistorialEstado ref="HistorialEstado" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import ChoferEstado from "./ChoferEstado";
import ChoferExport from "./ChoferExport";
import Loading from "../../../../components/Loading";
import pagination from "laravel-vue-pagination";
import HistorialEstado from "../../../admin/basico/historialEstado/HistorialEstado";
import { icons } from "feather-icons";

export default {
  name: "Choferes",
  components: {
    pagination,
    vSelect,
    Loading,
    ChoferEstado,
    ChoferExport,
    HistorialEstado,
  },
  data() {
    return {
      cargando: false,
      empresas: [],
      user: null,
      admin: null,
      empresa: this.$store.getters.getUser.empresas,
      tipo_usuario_cambia_estado: null,
      filtros: {
        tipo_documento: null,
        numero_documento: null,
        empresa_id: null,
        estado: null,
      },
      choferes: {},
      listasForms: {
        tipo_documentos: [],
        estados: [],
        selct_empresa: [],
      },
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  computed: {
    tiposDocumentoArgentina() {
      // Mapear tipos de documento colombianos a argentinos
      const mapeo = {
        "C.C": "DNI",
        "C.E": "CDI",
        Nit: "CUIT",
        Pasaporte: "Pasaporte",
        "Pasaporte 1": "Pasaporte",
      };

      return this.listasForms.tipo_documentos.map((tipo) => ({
        ...tipo,
        descripcion: mapeo[tipo.descripcion] || tipo.descripcion,
      }));
    },
  },
  methods: {
    getIndex(page = 1) {
      this.filtros.empresa_id = null;
      if (this.$store.state.user) {
        const administrador = this.$store.state.user.roles.find(
          (administrador) => administrador.id === 1,
        );
        if (administrador) {
          this.admin = administrador.id;
        }
      }
      // Se busca los permisos que tiene el usuario para editar los estados del chofer
      if (this.$store.getters.can("argentina.choferes.editStatusInspector")) {
        this.tipo_usuario_cambia_estado = `Inspector`;
      }
      if (this.$store.getters.can("argentina.choferes.editStatusHSE")) {
        this.tipo_usuario_cambia_estado = `HSE`;
      }
      if (this.listasForms.selct_empresa) {
        this.filtros.empresa_id = this.listasForms.selct_empresa.id;
      }
      this.cargando = true;
      axios
        .get("/api/argentina/choferes?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.choferes = response.data;
          this.cargando = false;
        })
        .catch((error) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrio un error al cargar los datos",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },
    getTiposIdentificacion() {
      axios.get("/api/lista/6").then((response) => {
        this.listasForms.tipo_documentos = response.data;
      });
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url =
          "/api/argentina/empresas/lista?razon_social=" + search + "&pais_id=3";
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.empresas = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    destroy(chofer) {      
      this.$swal({
        title: "¿Está seguro de eliminar este Chofer?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete("/api/argentina/choferes/" + chofer.id)
            .then(() => {
              this.getIndex();
              this.$swal({
                icon: "success",
                title: "Se eliminó el Chofer exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "No se puede eliminar",
                html: `El chofer tiene asociada la hoja de carga con Remito: ${error.response.data.digito_verificacion}-${error.response.data.numero}</b>`,
              });
            });
        }
      });
    },

    llenarModal(conductor) {
      if (
        this.$store.getters.can("argentina.choferes.editStatusHSE") ||
        this.$store.getters.can("argentina.choferes.editStatusInspector")
      ) {
        this.$refs.ChoferEstado.form_estado = {};
        this.$refs.ChoferEstado.llenar_modal(
          conductor,
          this.tipo_usuario_cambia_estado,
        );
      }
    },

    llenarModalHistorial(entidad, entidad_id) {
      this.$refs.HistorialEstado.llenar_modal(entidad, entidad_id);
    },

    create() {
      return this.$router.push({
        name: "/Argentina/Admin/ChoferForm",
        params: { accion: "Crear", id: 0 },
      });
    },

    edit(conductor, opcion) {
      return this.$router.push({
        name: "/Argentina/Admin/ChoferForm",
        params: {
          accion: "Editar",
          data_edit: conductor,
          id: conductor.id,
          opcion: opcion,
        },
      });
    },

    pivotTable() {
      return this.$router.push({
        name: "/Argentina/Admin/ChoferPivotTable",
      });
    },

    getMsg() {
      if (this.$route.params.msg) {
        this.$swal({
          icon: "success",
          title: this.$route.params.msg,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      }
    },

    limpiarFiltros() {
      this.filtros = {
        tipo_documento: null,
        numero_documento: null,
        nombre: null,
        estado: null,
        empresa_id: null,
      };
      this.listasForms.selct_empresa = null;
      this.choferes = {};
      this.getIndex();
    },
  },

  mounted() {
    this.getIndex();
    this.getEstados();
    this.getTiposIdentificacion();
    this.getMsg();
  },
};
</script>
